import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BodyShopComponent } from './bodyshop.component';
import { AuthGuard } from '../helpers/auth.guard';

const routes: Routes = [
  { path: '', component: BodyShopComponent, canActivate: [AuthGuard] }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BodyShopRoutes { }
